import httpManager from "../../../../shared/utils/httpManager";

export async function fetchListBases(search = "") {
  const url = `/entities/portfolios/bases/?search=${search}`;
  const response = await httpManager.get(url);
  return response?.data.results;
}
